<template>
  <v-container class="mb-12">
    <v-row class="justify-center mb-15">
      <!-- <v-btn
        class="white--text"
        :color="whitelabel.colors.primary"
        rounded
        depressed
        x-large
        to="/signup"
      >
        <span>DRAFT MY WILL FOR FREE</span
        ><v-icon small>{{ icons.mdiArrowRight }}</v-icon>
      </v-btn> -->

      <GradientButton
        @gradientButtonClicked="$router.push('/signup')"
        title="DRAFT MY WILL"
        :callout="'right'"
        class="mt-10"
      />
    </v-row>
    <v-row class="introduction-information-row">
      <div class="image-column">
        <img
          :src="
            require(`@/assets/old_mutual/estate-administration-cost-calculator/calculator-intro.svg`)
          "
          alt="Estate Administration Cost Calculator Intro"
          class="mb-1"
        />
      </div>
      <div class="intro-text-column">
        <h2 class="mb-11">Calculate the cost of your passing</h2>
        <p class="mb-7">
          In the event of your death there are a mandatory fees that
          automatically becomes payable.
        </p>

        <p>
          <strong
            >Try our free
            <router-link to="/estate-administration-cost-calculator"
              >Estate Administration Cost Calculator</router-link
            >
            to find out what you need to plan for.</strong
          >
        </p>
      </div>
    </v-row>
    <v-row class="justify-center mb-15 calculate-costs-row">
      <v-btn
        :color="whitelabel.colors.secondary"
        rounded
        depressed
        x-large
        to="/estate-administration-cost-calculator"
      >
        <span>CALCULATE MY COSTS NOW</span
        ><v-icon small>{{ icons.mdiArrowRight }}</v-icon>
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EstateAdministrationCostCalculatorIntro',
  };
</script>
<style lang="scss" scoped>
  h2 {
    font-size: 40px;
    line-height: normal;
  }

  .introduction-information-row {
    justify-content: center;
    align-items: center;
    padding-right: 210px;

    .intro-text-column {
      max-width: 450px;
    }

    .image-column {
      margin-left: -40px;
      margin-right: 60px;

      img {
        margin-left: -25px;
      }
    }
  }

  @media (max-width: 1260px) {
    .introduction-information-row {
      padding: 0 40px;

      h2 {
        text-align: center;
      }

      .image-column {
        margin: 0;

        img {
          margin: 0;
        }
      }
    }

    .calculate-costs-row {
      margin-top: 80px;
    }
  }
</style>
